// extracted by mini-css-extract-plugin
export var centerText = "_6g-8";
export var container = "_6g-0";
export var doughnutContainer = "_6g-7";
export var legend = "_6g-a";
export var legendItemColorDisplay = "_6g-b";
export var legendItemLabel = "_6g-d";
export var legendItemValue = "_6g-c";
export var lg = "_6g-5";
export var maxWidth = "_6g-9";
export var md = "_6g-4";
export var responsive = "_6g-6";
export var sm = "_6g-3";
export var xs = "_6g-2";
export var xxs = "_6g-1";